import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { Button, Dialog, DialogTitle, Grid, MenuItem, Toolbar, Typography } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from '@material-ui/icons/Cancel';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { ValidatorForm, TextValidator, SelectValidator } from "react-material-ui-form-validator";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { agregarEditarCuota } from "../../../../actions/facturacion/cuotas";
import { TIPO_AFILIACION } from "../../../../utils/constants";

const useStyles = makeStyles((theme) => ({
    root:{
        marginLeft: "auto",
        marginRight: "auto",
        width: "74%",
    },
    header:{
        background: '#68389F',
        color:'white'
      },
    botonera: {
        marginTop: 50,
        marginLeft: 55,
        marginBottom: 20,
        paddingBottom: 13
    },
    withoutLabel: {
        marginTop: theme.spacing(2),
    },
}));

const initialState = {
    idTipoAfiliacion: '',
    sitRevistaAportes: '',
    descripcion:'',
    edadDesde: '',
    edadHasta: '',
    fechaDesde: new Date(),
    fechaHasta: null,
    cuota:'',
    cuotaFamiliar:'',
    idCuota: 0,
  }

export const ModalAltaCuota = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { open, setOpen, title } = props;
    const [ cuotaNueva, setCuotaNueva ] = useState({ ...initialState });

    const handleSave = () => {
        dispatch( 
            agregarEditarCuota(
                cuotaNueva
                ,closeModal
            )
        );
    }

    const closeModal = () => {
        setOpen(false);
        setCuotaNueva({ ...initialState });
    }
    
    const handleInputChange = (e) => {
        setCuotaNueva({...cuotaNueva, [e.target.name]:e.target.value});
    }
    
    return (
        <Dialog
            maxWidth="md"
            fullWidth={true}
            open={open}
            onClose={closeModal}
        >
            <DialogTitle className={classes.header}>
                <Toolbar >
                    <Typography variant="h6" >
                        {title}
                    </Typography>
                </Toolbar>
            </DialogTitle>
            <ValidatorForm onSubmit={() => handleSave()}>
                <div className={classes.root}>
                    <Grid container >
                        <Grid item xs={12} >
                            <TextValidator
                                fullWidth
                                margin="normal"
                                label="Descripción"
                                name="descripcion"
                                value={cuotaNueva.descripcion}
                                autoComplete="off"
                                inputProps={{ maxLength: 250 }}                                
                                onChange={handleInputChange}
                                multiline={true}
                                validators={["required"]}
                                errorMessages={["Este campo es obligatorio"]}
                            />
                        </Grid>
                    </Grid>
                    <Grid container alignItems="center" justify="center" >
                        <Grid item xs={12} md={4} style={{marginRight: 35}} >
                            <SelectValidator
                                style={{marginTop: 25}}
                                fullWidth={true}
                                margin="normal"
                                value={cuotaNueva.idTipoAfiliacion}
                                name="idTipoAfiliacion"
                                onChange={handleInputChange}
                                InputLabelProps={{ shrink: true }}  
                                label="Tipo Afiliación"
                                validators={['required']}
                                errorMessages={['Seleccione una opción']}
                            >
                                <MenuItem value="">
                                    <em>Seleccione</em>
                                </MenuItem>
                                <MenuItem key={TIPO_AFILIACION.DJ} value={TIPO_AFILIACION.DJ}>DJ</MenuItem>
                                <MenuItem key={TIPO_AFILIACION.TEMPORARIO_CON_CUOTA} value={TIPO_AFILIACION.TEMPORARIO_CON_CUOTA}>TEMPORARIO CON CUOTA</MenuItem>
                                <MenuItem key={TIPO_AFILIACION.TEMPORARIO} value={TIPO_AFILIACION.TEMPORARIO}>TEMPORARIO</MenuItem>
                                <MenuItem key={TIPO_AFILIACION.ADHERENTE} value={TIPO_AFILIACION.ADHERENTE}>ADHERENTE</MenuItem>
                            </SelectValidator>
                        </Grid>
                        <Grid item xs={12} md={4} >
                            <TextValidator
                                style={{minWidth: 237}}
                                label="Situación Revista Aportes"
                                name="sitRevistaAportes"
                                onChange={handleInputChange}
                                className={classes.withoutLabel}
                                InputLabelProps={{ shrink: true }}  
                                value={cuotaNueva.sitRevistaAportes}
                                validators={['matchRegexp:^[0-9]+$']}
                                errorMessages={['Solo se permiten números positivos enteros']}
                            />
                        </Grid>
                    </Grid>
                    <Grid container alignItems="center" justify="center" >
                        <Grid item xs={12} md={4} style={{marginRight: 35}} >
                            <TextValidator
                                style={{minWidth: 237}}
                                label="Edad Desde"
                                name="edadDesde"
                                onChange={handleInputChange}
                                className={classes.withoutLabel}
                                InputLabelProps={{ shrink: true }}  
                                value={cuotaNueva.edadDesde}
                                validators={['required', 'matchRegexp:^[0-9]+$', 'maxNumber:150']}
                                errorMessages={[
                                    'El valor es requerido'
                                    ,'Solo se permiten números positivos enteros'
                                    ,'Máximo valor debe ser menor a 150'
                                ]}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} >
                            <TextValidator
                                style={{minWidth: 237}}
                                label="Edad Hasta"
                                name="edadHasta"
                                onChange={handleInputChange}
                                className={classes.withoutLabel}
                                InputLabelProps={{ shrink: true }}  
                                value={cuotaNueva.edadHasta}
                                validators={['required', 'matchRegexp:^[0-9]+$', 'maxNumber:150']}
                                errorMessages={[
                                    'El valor es requerido'
                                    ,'Solo se permiten números positivos enteros'
                                    ,'Máximo valor debe ser menor a 150'
                                ]}
                            />
                        </Grid>
                    </Grid>
                    <Grid container alignItems="center" justify="center" >
                        <Grid item xs={12} md={4} style={{marginRight: 35}} >
                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    id="date-picker-dialog"
                                    label="Fecha Desde"
                                    format="dd/MM/yyyy"
                                    okLabel="Aceptar"
                                    required={true}
                                    minDate={new Date()}
                                    clearLabel="Limpiar"
                                    cancelLabel="Cancelar"
                                    minDateMessage={`La fecha no puede ser anterior a la fecha actual`}
                                    value={cuotaNueva.fechaDesde}
                                    onChange={(e) => handleInputChange({target: {name: 'fechaDesde', value: e}})}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} md={4} >
                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    id="date-picker-dialog"
                                    label="Fecha Hasta"
                                    format="dd/MM/yyyy"
                                    okLabel="Aceptar"
                                    clearLabel="Limpiar"
                                    cancelLabel="Cancelar"
                                    value={cuotaNueva.fechaHasta}
                                    onChange={(e) => handleInputChange({target: {name: 'fechaHasta', value: e}})}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                    </Grid>
                    <Grid container alignItems="center" justify="center" >
                        <Grid item xs={12} md={4} style={{marginRight: 35}} >
                            <TextValidator
                                style={{minWidth: 237}}
                                label="Importe Cuota"
                                name="cuota"
                                onChange={handleInputChange}
                                className={classes.withoutLabel}
                                InputLabelProps={{ shrink: true }}  
                                value={cuotaNueva.cuota}
                                validators={['required', 'isPositive']}
                                errorMessages={['El valor es requerido', 'Solo se permiten números']}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} >
                            <TextValidator
                                style={{minWidth: 237}}
                                label="Importe Cuota Familiar"
                                name="cuotaFamiliar"
                                onChange={handleInputChange}
                                className={classes.withoutLabel}
                                InputLabelProps={{ shrink: true }}  
                                value={cuotaNueva.cuotaFamiliar}
                                validators={['required', 'isPositive']}
                                errorMessages={['El valor es requerido', 'Solo se permiten números']}
                            />
                        </Grid>
                    </Grid>
                        
                    <Grid className={classes.botonera} container >
                        <Grid item xs={10}>
                            <Grid
                                container
                                direction="row"
                                justify="space-between"
                                alignItems="center"
                            >
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    startIcon={<CancelIcon />}
                                    onClick={closeModal}
                                >
                                    CANCELAR
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<SaveIcon />}
                                    type="submit"
                                >
                                    GUARDAR
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </ValidatorForm>
        </Dialog>
    );

};
